// extracted by mini-css-extract-plugin
module.exports = {"col":"col-21B98B9Y clearfix","col_L":"col_L-3qVs5-D8 clearfix","ad":"ad-2N3HclhL","box":"box-1XQoREId"};